import React from 'react';
import PropTypes from 'prop-types';
import BuyIcon from '../../../../../illustrations/buy.png';
import RefinanceIcon from '../../../../../illustrations/refinance.png';
import EquityIcon from '../../../../../illustrations/equity.png';
import * as Classes from './icon.module.scss';

const Icon = ({ id, alt }) => 
{
    const renderIcon = () => 
    {
        switch (id) 
        {
            case 'buy':
                return <img className={Classes.icon} src={BuyIcon} alt={alt} />;
            case 'refinance':
                return (
                    <img
                        className={Classes.icon}
                        src={RefinanceIcon}
                        alt={alt}
                    />
                );
            case 'equity':
                return (
                    <img className={Classes.icon} src={EquityIcon} alt={alt} />
                );
            default:
                return <img className={Classes.icon} src={BuyIcon} alt={alt} />;
        }
    };
    return renderIcon();
};

export default Icon;
Icon.propTypes = {
    id: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
};
